import React, { useState, useEffect } from "react";
import "./dashboard.scss";
import {
  facultyMembersApi,
  facultyDepartmentApi,
  ugProgrammesApi,
  pgProgrammesApi,
  syllabusApi,
  timeTableManagementApi,
  examinationScheduleApi,
  resultsApi,
  photoGalleryApi,
  videosApi,
  pressReleaseApi,
  departmentNoticesApi
} from "../../config/api";
import { apiClient } from "../../utils/apiClient";

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalFaculty: 0,
    departments: 0,
    ugProgrammes: 0,
    pgProgrammes: 0,
    syllabus: 0,
    timeTables: 0,
    examNotices: 0,
    examSchedules: 0,
    results: 0,
    pendingUpdates: 0,
    photoGallery: 0,
    videos: 0,
    pressReleases: 0,
    activeNotices: 0,
  });

  useEffect(() => {
    const fetchCounts = async () => {
      const endpoints = [
        { key: 'totalFaculty', url: facultyMembersApi },
        { key: 'departments', url: facultyDepartmentApi },
        { key: 'ugProgrammes', url: ugProgrammesApi },
        { key: 'pgProgrammes', url: pgProgrammesApi },
        { key: 'syllabus', url: syllabusApi },
        { key: 'timeTables', url: timeTableManagementApi },
        { key: 'examSchedules', url: examinationScheduleApi },
        { key: 'results', url: resultsApi },
        { key: 'photoGallery', url: photoGalleryApi },
        { key: 'videos', url: videosApi },
        { key: 'pressReleases', url: pressReleaseApi },
        { key: 'activeNotices', url: departmentNoticesApi },
      ];

      const promises = endpoints.map(async (ep) => {
        try {
          const res = await apiClient(ep.url);
          const data = await res.json();
          const list = data.data || data || [];
          return { key: ep.key, count: Array.isArray(list) ? list.length : 0 };
        } catch (e) {
          console.error(`Error fetching ${ep.key}:`, e);
          return { key: ep.key, count: 0 };
        }
      });

      const results = await Promise.allSettled(promises);
      const newStats = { ...stats };
      results.forEach((r) => {
        if (r.status === 'fulfilled') {
          newStats[r.value.key] = r.value.count;
        }
      });
      setStats(newStats);
    };

    fetchCounts();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="dashboard-page">
      <div className="dashboard-header">
        <h1>Dashboard</h1>
        <p>
          Welcome to the college admin panel. Manage content, faculty,
          academics, media, notices, and website updates from one place.
        </p>
      </div>

      <div className="dashboard-section">
        <div className="section-heading">
          <h2>Faculty Overview</h2>
          <p>Quick summary of faculty-related records.</p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <h3>Total Faculty</h3>
            <p>{stats.totalFaculty}</p>
          </div>
          <div className="stat-card">
            <h3>Total PG Faculty</h3>
            <p>-</p>
          </div>
          <div className="stat-card">
            <h3>Guest Faculty</h3>
            <p>-</p>
          </div>
          <div className="stat-card">
            <h3>Departments</h3>
            <p>{stats.departments}</p>
          </div>
        </div>
      </div>

      <div className="dashboard-section">
        <div className="section-heading">
          <h2>Academics Overview</h2>
          <p>Programmes, admissions, syllabus, and timetable details.</p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <h3>UG Programmes</h3>
            <p>{stats.ugProgrammes}</p>
          </div>
          <div className="stat-card">
            <h3>PG Programmes</h3>
            <p>{stats.pgProgrammes}</p>
          </div>
          <div className="stat-card">
            <h3>Syllabus Uploaded</h3>
            <p>{stats.syllabus}</p>
          </div>
          <div className="stat-card">
            <h3>Time Tables</h3>
            <p>{stats.timeTables}</p>
          </div>
        </div>
      </div>

      <div className="dashboard-section">
        <div className="section-heading">
          <h2>Examination Overview</h2>
          <p>Track notices, schedules, and result updates.</p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <h3>Exam Notices</h3>
            <p>{stats.examNotices}</p>
          </div>
          <div className="stat-card">
            <h3>Exam Schedules</h3>
            <p>{stats.examSchedules}</p>
          </div>
          <div className="stat-card">
            <h3>Results Published</h3>
            <p>{stats.results}</p>
          </div>
          <div className="stat-card">
            <h3>Pending Updates</h3>
            <p>{stats.pendingUpdates}</p>
          </div>
        </div>
      </div>

      <div className="dashboard-section">
        <div className="section-heading">
          <h2>Media & Notice Overview</h2>
          <p>Manage media assets, announcements, and public updates.</p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <h3>Photo Gallery Items</h3>
            <p>{stats.photoGallery}</p>
          </div>
          <div className="stat-card">
            <h3>Videos</h3>
            <p>{stats.videos}</p>
          </div>
          <div className="stat-card">
            <h3>Press Releases</h3>
            <p>{stats.pressReleases}</p>
          </div>
          <div className="stat-card">
            <h3>Active Notices</h3>
            <p>{stats.activeNotices}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;